let STAGE_CONFIG = {
    PROD: {
        APP_ROOT: 'https://qccloud.net/api/v1'
    },
    STAGE: {
        APP_ROOT: 'http://stage.qccloud.net/api/v1'

    },
    DEV: {
        APP_ROOT: 'http://localhost:3000/api/v1'
    }
};

let CONSTANTS = {
	APP_TITLE: 'QuickFit',
	BASE_URL: '/:bname',
	TOKEN_EXPIRY_SECONDS: 1800,
	SLOT_MINUTES: 30,
	DEFAULTS: {
		CURRENCY: '$'
	},
	URLS: {
		ROOT: STAGE_CONFIG[process.env.REACT_APP_STAGE].APP_ROOT,
		END_POINTS: {
			MEMBER: {
				REFRESH_TOKEN: '/login/member_api/refresh_token',
				SIGN_UP: {
					CHECK_EMAIL: '/sign_up/member_api/sign_up/check_email',
					COMPLETE_SIGN_UP: '/sign_up/member_api/sign_up/complete',
					SET_PASSWORD: '/sign_up/member_api/sign_up/set_password'
				},
				LOGIN: '/login/member_api/login_member',
				SET_RESET_PASSWORD_TOKEN: '/login/member_api/set_reset_password_token',
				RESET_PASSWORD: '/login/member_api/reset_password',
				CHANGE_PASSWORD: '/members/member_api/member/change_password',
				PROFILE: '/members/member_api/member',
				MEMBERSHIPS: '/members/member_api/member/memberships',
				ACCOUNTS: '/members/member_api/member/accounts',
			},
			USER: {
				TRAINERS: '/users/trainers',
				BUSINESS_HOURS: (trainerId) => { return `/users/trainers/${trainerId}/business_hours`; }
			},
			APPOINTMENTS: '/appointments/member_api/member/appointments',
			CHECKINS: '/checkin/member_api/member/checkins',
			CONFIG: {
				ACTIVITIES: '/activities'
			},
			POS: {
				ORDERS: '/pos/member_api/orders',
				PRODUCTS: '/pos/products',
				CATEGORIES: '/pos/categories',
				CONFIG: '/pos/config'
			},
		}
	},
	ACTIONS: {
		LOGIN:{
			SUCCESS: 'login_success',
			FAILURE: 'login_failure'
		},
		LOGOUT: 'logout',
		MEMBER: {
			GET: {
				PROFILE: 'get_profile',
				MEMBERSHIPS: 'get_memberships',
				MEMBERSHIP: 'get_membership',
				ACCOUNTS: 'get_accounts',
				ACCOUNT: 'get_account',
			}
		},
		USER: {
			GET: {
				TRAINERS: 'get_trainers',
				BUSINESS_HOURS: 'get_business_hours'
			}
		},
		APPOINTMENT: {
			CREATE: 'create_appointment',
			CANCEL: 'cancel_appointment',
			CONFIRM: 'confirm_appointment',
			GET: {
				APPOINTMENTS: 'get_appointments',
				APPOINTMENT: 'get_appointment',
				SCHEDULE: 'get_schedule',
			}
		},
		CHECKIN: {
			CREATE: 'CREATE_CHECKIN',
			GET: {
				CHECKINS: 'get_checkins'
			}
		},
		CONFIG: {
		  GET: {
		  	ACTIVITIES: 'get_activities'
		  }
		},
		POS: {
			GET: {
				CATEGORIES: 'get_categories',
				PRODUCTS: 'get_products',
				CONFIG: 'get_pos_config',
				ORDER: 'get_order'
			},
			CREATE: {
				ORDER: 'create_order'
			}
		},
		SPINNER: {
			SHOW: 'show_spinner',
			HIDE: 'hide_spinner'
		}
	},
	ALERTS: {
		DURATION: 5000,
		SUCCESS: 'alert_success',
		ERROR:   'alert_error',
		WARNING: 'alert_warning',
		CLEAR:   'alert_clear'
	},
	DATE: {
		FORMAT: {
			SERVER: 'MM/DD-YYYY',
			DEFAULT: 'YYYY-MM-DD',
			DISPLAY: 'MM/DD/YYYY'
		}
	},
	TIME: {
		FORMAT: {
			SERVER: 'hh:mm a',
			DEFAULT: 'HH:mm:ss',
			DISPLAY: 'hh:mm a'
		}
	},
	STATUS: {
		MEMBERSHIP: {
			ACTIVE: 1,
			INACTIVE: 0
		},
		ACCOUNT: {
			ACTIVE: 1,
			INACTIVE: 0
		}
	},
	FILTERS: {
		TYPES: {
			DATE: 'date',
			BOOL: 'bool',
			SELECT: 'select',
			STRING: 'string',
			INTEGER: 'integer'
		}
	},
	ERRORS: {
		NO_MEMBERSHIP: 104
	},
	SETTINGS: {
		CHECKINS: {
			DENIED_CHECKIN: 1,
		}
	}
};

export default CONSTANTS;